import { isUndefined, omitBy } from 'lodash';
import request from '@/utils/request';
import {
  attachmentDictionaryEndpoint,
  attachmentDictionaryIngestEndpoint,
  attachmentsEndpoint,
  datasetFolderEndpoint,
  downloadEndpointDatasetAttachments,
} from '@/constants/urls';
import { ATTACHMENT_TYPE } from './constants';

const datasetAttachments = (
  code,
  onlyTransferable = undefined,
  includeFolders = true,
  path = undefined,
) => request({
  method: 'GET',
  url: attachmentsEndpoint(code),
  params: omitBy({
    only_transferable: onlyTransferable,
    include_folders: includeFolders,
    path: path === '' ? undefined : path,
  }, isUndefined),
});

const destroy = ({ metadata, id }) => {
  const endpoint = metadata.dataset_file_type === ATTACHMENT_TYPE.folder.name
    ? datasetFolderEndpoint(metadata.dataset_code, id) : attachmentsEndpoint(metadata.dataset_code, id);
  return request({
    method: 'DELETE',
    url: endpoint,
  });
};

const dictionary = (code, attachmentId) => request({
  method: 'GET',
  url: attachmentDictionaryEndpoint(code, attachmentId),
});

const download = (code, attachmentId) => request({
  headers: { 'ARIDHIA-FAIR-Parent-Model-ID': code },
  method: 'GET',
  responseType: 'blob',
  url: downloadEndpointDatasetAttachments(code, attachmentId),
});

const prepareDownload = (code, attachmentId) => request({
  headers: { 'ARIDHIA-FAIR-Parent-Model-ID': code, 'X-Prepare-Download': true },
  method: 'HEAD',
  url: downloadEndpointDatasetAttachments(code, attachmentId),
});

const updateMetadata = (code, attachmentId, metadata) => request({
  method: 'PATCH',
  url: `${attachmentsEndpoint(code, attachmentId)}/metadata`,
  data: metadata,
});

const ingest = (code, attachmentId, properties) => {
  const data = {
    delete_source: properties.deleteSource,
    dictionary_code: properties.dictionaryCode,
  };
  return request({
    data,
    method: 'POST',
    url: attachmentDictionaryIngestEndpoint(code, attachmentId),
  });
};

const createFolder = (code, folderPath) => request({
  method: 'POST',
  url: datasetFolderEndpoint(code, folderPath),
});

const deleteFolder = (code, folderPath) => request({
  method: 'DELETE',
  url: datasetFolderEndpoint(code, folderPath),
});

const DatasetAttachmentsService = {
  createFolder,
  deleteFolder,
  datasetAttachments,
  destroy,
  dictionary,
  download,
  ingest,
  prepareDownload,
  updateMetadata,
};

export default DatasetAttachmentsService;
